export default __webpack_public_path__ + "static/media/maintenance.a0dd8fa9.svg";